import React from 'react';
import { MOCK_AREAS } from '../../data/mockAreas';

// Check if running locally
const IS_LOCAL_DEV = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

export default function AreasListCard({ 
    areas = [], 
    selectedItem, 
    onAreaSelect, 
    isPending = false 
}) {
    // Combine real areas with mock areas (only in local dev)
    const combinedAreas = IS_LOCAL_DEV && (!areas || areas.length === 0) 
        ? MOCK_AREAS 
        : areas;
    
    const areaNames = combinedAreas ? combinedAreas.map(area => area.name) : [];

    // Group areas alphabetically by first letter
    const groupedAreas = areaNames.reduce((acc, name) => {
        const firstLetter = name[0].toUpperCase();
        if (!acc[firstLetter]) acc[firstLetter] = [];
        acc[firstLetter].push(name);
        return acc;
    }, {});

    return (
        <div className="bg-white shadow-lg rounded-lg border border-gray-200 overflow-hidden h-[550px] flex flex-col">
            {/* Card Header */}
            <div className="bg-gray-500 px-6 py-4 border-b border-gray-200">
                <h2 className="text-xl font-bold text-white">
                    Naturområden
                </h2>
                <p className="text-sm text-white/80 mt-1">
                    Välj ett område att redigera
                </p>
            </div>
            
            {/* Card Content - Scrollable List with Alphabetical Grouping */}
            <div className="flex-1 overflow-auto">
                {isPending ? (
                    <div className="flex items-center justify-center h-full">
                        <div className="text-center text-gray-500">
                            <svg className="animate-spin h-8 w-8 mx-auto mb-3 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                            <p>Laddar områden...</p>
                        </div>
                    </div>
                ) : combinedAreas && combinedAreas.length > 0 ? (
                    <div>
                        {Object.keys(groupedAreas)
                            .sort()
                            .map((letter) => (
                                <div key={letter}>
                                    {/* Sticky Alphabet Header */}
                                    <div className="sticky top-0 bg-gray-100 px-4 py-2 text-sm font-semibold uppercase tracking-wide text-gray-600 border-b border-gray-200">
                                        {letter}
                                    </div>
                                    {/* Areas under this letter */}
                                    <ul className="divide-y divide-gray-100">
                                        {groupedAreas[letter].map((name) => (
                                            <li key={name}>
                                                <button
                                                    className={`w-full text-left py-3 px-4 transition-all duration-200 ${
                                                        selectedItem === name
                                                            ? 'bg-gray-500 text-white'
                                                            : 'bg-white text-gray-700 hover:bg-gray-50'
                                                    }`}
                                                    onClick={() => onAreaSelect(name)}
                                                    id={"area" + name}
                                                >
                                                    <span className="font-medium">{name}</span>
                                                </button>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                    </div>
                ) : (
                    <div className="flex items-center justify-center h-full">
                        <div className="text-center text-gray-500 px-4">
                            <svg className="w-12 h-12 mx-auto mb-3 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
                            </svg>
                            <p>Inga områden hittades</p>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}